/* eslint-disable max-len */
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'interfaces';
import { initialState } from './slice';

const selectDomain = (state: RootState) => state['feature/session/summary'] || initialState;

export const selectLoader = createSelector([selectDomain], (SessionSummaryState) => SessionSummaryState.loading);
export const selectActionLoader = createSelector([selectDomain], (SessionSummaryState) => SessionSummaryState.actionLoading);
export const selectSession = createSelector([selectDomain], (SessionSummaryState) => SessionSummaryState.session);
export const selectSessionUrl = createSelector([selectDomain], (SessionSummaryState) => SessionSummaryState.sessionUrl);
